/* eslint-disable import/no-anonymous-default-export */
import { all } from 'redux-saga/effects';

export default function* () {
  yield all([]);
}
